// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-DataTable {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.FF-DataTable-search {
  max-width: 400px;
}

.FF-DataTable-table {
  flex: 1;
}

.FF-DataTable-loading {
  display: flex;
  justify-content: center;
  padding: 12px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/DataTable/DataTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B","sourcesContent":[".FF-DataTable {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.FF-DataTable-search {\n  max-width: 400px;\n}\n\n.FF-DataTable-table {\n  flex: 1;\n}\n\n.FF-DataTable-loading {\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
